/**
 * Consent API client for the MCP OAuth flow (/api/oauth).
 */
import { getIdToken } from '../contexts/AuthContext';
import { buildApiUrl, getAuthHeaders } from '../config/api';

async function authedFetch(endpoint, options = {}) {
  const idToken = await getIdToken();
  if (!idToken) throw new Error('Not authenticated. Please log in.');
  const response = await fetch(buildApiUrl(endpoint), {
    ...options,
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders(idToken), ...(options.headers || {}) },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body.message || body.error || `Request failed: ${response.statusText}`);
    error.status = response.status;
    throw error;
  }
  return body;
}

/** { request: { clientName, clientUri, redirectUri, scopes, resource, expiresAt }, account: { email } } */
export const fetchOAuthRequest = (requestId) => authedFetch(`/oauth/requests/${encodeURIComponent(requestId)}`);

/** { redirectUrl } */
export const approveOAuthRequest = (requestId) => authedFetch(`/oauth/requests/${encodeURIComponent(requestId)}/approve`, { method: 'POST' });

/** { redirectUrl } */
export const denyOAuthRequest = (requestId) => authedFetch(`/oauth/requests/${encodeURIComponent(requestId)}/deny`, { method: 'POST' });
